export const currentDate = (isEn) => {
	const newDate = new Date();
	const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
	const enMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	const date_raw = newDate.getDate();
	const month_raw = newDate.getMonth();
	const year = newDate.getFullYear();
	return `${date_raw} ${isEn ? enMonths[month_raw] : months[month_raw]} ${year}`;
};
